import { render } from "./BannerManage.vue?vue&type=template&id=c353d3ac&scoped=true"
import script from "./BannerManage.vue?vue&type=script&lang=js"
export * from "./BannerManage.vue?vue&type=script&lang=js"

import "./BannerManage.vue?vue&type=style&index=0&id=c353d3ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c353d3ac"]])

export default __exports__